import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'

import { Chip, Stack } from '@mui/material'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'

import { Expertise } from '@/core/models/expertise.model'

type ExpertiseHeaderProps = {
  isDoctor: boolean
  speciality?: string
  status: Expertise['status']
  startDate: string
  endDate?: string
}

export function ExpertiseHeader(props: ExpertiseHeaderProps) {
  const { isDoctor, speciality, status, startDate, endDate } = props
  const { t } = useTranslation()

  const getColor = (status: string) => {
    switch (status) {
      case 'draft':
        return 'secondary'
      case 'sent':
        return 'success'
      case 'reviewed':
        return isDoctor ? 'success' : 'primary'
      case 'closed':
        return 'warning'
    }
  }

  return (
    <Stack alignItems="right" direction={{ xs: 'column', sm: 'row' }} spacing={3}>
      <Chip
        color="secondary"
        label={
          <Stack direction="row" alignItems="center" spacing={1}>
            <span>
              {dayjs(startDate).format('DD/MM/YYYY')} - <b>{dayjs(startDate).format('HH[h]mm')}</b>
            </span>
            {endDate && (
              <>
                <ArrowForwardIcon fontSize="small" />
                <span>
                  {dayjs(endDate).format('DD/MM/YYYY')} - <b>{dayjs(endDate).format('HH[h]mm')}</b>
                </span>
              </>
            )}
          </Stack>
        }
        variant="filled"
      />
      {speciality && <Chip color={'primary'} style={{ fontWeight: 'bold' }} label={speciality.toUpperCase()} />}
      <Chip
        color={getColor(status)}
        style={{ fontWeight: 'bold' }}
        label={t(`common:model.expertise.status.${status}.label`, { context: isDoctor ? 'doctor' : 'pds' }).toUpperCase()}
      />
    </Stack>
  )
}

export default ExpertiseHeader
